<div class="container m-b-5">
  <div class="row animate fadeIn">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <input #input (keyup)="buscarSolicitudesArrendatario(input.value)" type="text" class="form-control"
            placeholder="Buscar solicitudes.">
        </div>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-12">
      <button (click)="regresarPagina()" style="width: 100px; height: 30px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
      <div class="card">
        <div class="card-body">
          <h3 class="card-title">Has realizado (<small>{{_visitaArrendatarioService.totalSolicitudVisitas}}</small>) solicitudes</h3>
          <table class="table table-hover table-responsive-xl" style="width:100%; overflow-x: auto;" >

            <div class="alert alert-info" *ngIf="visitas.length === 0" >
              No hay resultados de la búsqueda
            </div>

            <thead>
              <tr>
                <th><b>Estado</b></th>
                <th><b>Fecha solicitada</b></th>
                <th>Ver inmueble</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let visita of visitas">
                <td>{{visita.estado}}</td>
                <td>{{visita.fecha| date:'dd-MM-yyyy'}}</td>
                <td>
                 <button [routerLink]="['/ver-visitas-arrendatario', visita._id]" class="btn btn-primary"><i
                      class="fa fa-eye"></i></button>
                   <button (click)="borrarVisita(visita)" [hidden]="visita.estado==='ACEPTADA' || visita.estado==='ATENDIDA' || visita.estado==='ELIMINADA'" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
          <button (click)="cambiarPaginacion(-6)" class="btn btn-secondary m-r-5">Anteriores</button>
          <button (click)="cambiarPaginacion(6)" class="btn btn-secondary">Siguientes</button>
        </div>
